import { NavigateFunction } from 'react-router'

import { api } from 'app/services'
import { report } from 'utils'

export const fetchOauthNonce = (
  quoteId: string,
  setOauthNonce: (token: string) => void,
  navigate: NavigateFunction,
) => {
  api
    .get(`/quoting/v2/quotes/${quoteId}`)
    .then((response) => {
      if (response.status === 403) {
        throw new Error('open_banking_session_expired')
      }

      if (!response.data.fraud.openBankingOAuthNonce) {
        throw new Error('wrong_segment')
      }

      setOauthNonce(response.data.fraud.openBankingOAuthNonce)
    })
    .catch((error: Error) => {
      report(error, 'Fetch Quote on Connect Your Bank')
      navigate(`/quote/${quoteId}/connect-your-bank/error?errorCode=${error.message}`)
    })
}
